<footer class="footer">
  <div class="footer__root container" [class.show-account]="isLoggedIn">
    <section class="footer__logo">
      <a href="/?sh=true" class="logo" data-ga-value="footer-link-logo">
        <img
          src="/shared/img/logo/desktop/fantaz_logo_{{
            theme === 'light' ? 'black' : 'white'
          }}_1x.webp"
          srcset="
          /shared/img/logo/desktop/fantaz_logo_{{
            theme === 'light' ? 'black' : 'white'
          }}_1x.webp 1x,
            /shared/img/logo/desktop/fantaz_logo_{{
            theme === 'light' ? 'black' : 'white'
          }}_2x.webp 2x,
            /shared/img/logo/desktop/fantaz_logo_{{
            theme === 'light' ? 'black' : 'white'
          }}_3x.webp 3x,
            /shared/img/logo/desktop/fantaz_logo_{{
            theme === 'light' ? 'black' : 'white'
          }}_4x.webp 4x
          "
          alt="FantaZ Logo"
          height="42"
          loading="lazy"
        />
      </a>
    </section>

    <section class="age-text">
      <p>+18 years old to play for cash.</p>
    </section>
    <section class="empty"></section>

    @if (isLoggedIn) {
      <section class="footer__my_account_links">
        <ul class="footer_menu_links">
          <li class="link-title">My account</li>
          <li>
            <a
              href="/profile"
              target="_self"
              data-ga-value="footer-link-profile"
              >Profile</a
            >
          </li>
          <li>
            <a
              href="/tournaments/gamehistory"
              target="_self"
              data-ga-value="footer-link-game-history"
              >Game History</a
            >
          </li>
          <li>
            <a href="/wallet" target="_self" data-ga-value="footer-link-wallet"
              >Z-Wallet</a
            >
          </li>
          <li>
            <a
              href="/wallet/history"
              target="_self"
              data-ga-value="footer-link-transaction"
              >Transactions
            </a>
          </li>
        </ul>
      </section>
    }

    <section class="footer__play_links">
      <ul class="footer_menu_links">
        <li class="link-title">Play</li>
        <li>
          <a
            href="/tournaments?filterbytags={{
              TournamentTagsEnum.CASH_TOURNAMENT.toLowerCase().replace(' ', '-')
            }}"
            data-ga-value="footer-link-cash-tournament"
            >Cash Prize Tournaments</a
          >
        </li>
        <li>
          <a
            class="link"
            href="/tournaments?filterbytags={{
              TournamentTagsEnum.PRIZE_TOURNAMENT.toLowerCase().replace(
                ' ',
                '-'
              )
            }}"
            data-ga-value="footer-link-prizes-tournament"
            >Prize Tournaments</a
          >
        </li>
      </ul>
    </section>

    <section class="footer__promote_link">
      <ul class="footer_menu_links">
        <li class="link-title">Links</li>
        <li><a class="link" (click)="onPromote()">Promote</a></li>
        <li>
          <a
            class="mat-body-3"
            href="/profit"
            target="_self"
            data-ga-value="footer-link-profit"
            >Profit</a
          >
        </li>
        <li>
          <a
            (click)="onZendeskPressed()"
            href="https://fantaz.zendesk.com/hc/en-us"
            target="_blank"
            data-ga-value="footer-link-news"
            >News & FAQs
          </a>
        </li>
      </ul>
    </section>

    <section class="footer__social_links">
      <a
        class="social-network facebook"
        href="https://www.facebook.com/FantaZCorp"
        target="_blank"
        matTooltip="Facebook"
        data-ga-value="footer-link-facebook"
      >
        <img
          src="/shared/img/icons/facebook-icon.png"
          alt="Facebook"
          loading="lazy"
        />
      </a>
      <a
        class="social-network tiktok"
        href="https://www.tiktok.com/@fantaz.com"
        target="_blank"
        matTooltip="Tiktok"
        data-ga-value="footer-link-tiktok"
      >
        <img
          src="/shared/svg/tiktok{{ theme === 'light' ? '_dark' : '' }}.svg"
          alt="Tiktok"
          loading="lazy"
        />
      </a>
      <a
        class="social-network twitter"
        href="https://x.com/fantazcorp?lang=en"
        target="_blank"
        matTooltip="Twitter"
        data-ga-value="footer-link-twitter"
      >
        <img
          src="/shared/img/social_icon_twitter_{{
            theme === 'light' ? 'black' : 'white'
          }}.png"
          alt="Twitter icon"
          loading="lazy"
        />
      </a>
      <a
        class="social-network instagram"
        href="https://www.instagram.com/fantaz_corp/"
        target="_blank"
        matTooltip="Instagram"
        data-ga-value="footer-link-instagram"
        ><img
          src="/shared/img/icons/instagram-icon.png"
          alt="Instagram"
          loading="lazy"
        />
      </a>
      <a
        class="social-network youtube"
        href="https://www.youtube.com/@FantaZCorp"
        target="_blank"
        matTooltip="Youtube"
        data-ga-value="footer-link-youtube"
      >
        <img
          src="/shared/img/icons/youtube-icon.png"
          alt="Youtube"
          loading="lazy"
        />
      </a>
    </section>

    <section class="footer__copyright">
      <p class="copyright">©Copyright 2013-{{ currentYear }} FantaZ.</p>
      <p class="mb--3">
        Use of this site constitutes acceptance of our
        <br />
        <a
          class="link primary-color"
          href="/policies/terms"
          target="_blank"
          data-ga-value="footer-link-tac"
          >Terms and Conditions</a
        >,&nbsp;and our
        <a
          class="link primary-color"
          href="/policies/privacy"
          target="_blank"
          data-ga-value="footer-link-privacy"
          >Privacy Policy</a
        >.
      </p>
      <a
        class="link primary-color"
        data-ga-value="footer-link-not-sell-or-share-my-data"
        href="/profile/preferences?open=dontSellMyInfo"
        (click)="onNotSellOrShareMyData($event)"
      >
        Do not sell or share my personal information.
      </a>
    </section>
  </div>
</footer>
